import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=5b768c42&scoped=true&functional=true&"
var script = {}
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=5b768c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5b768c42",
  null
  
)

export default component.exports